import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import api from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

export function LoginCliente() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth } = useAuthStore();
  
  const [form, setForm] = useState({
    email: '',
    senha: '',
  });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const from = (location.state as any)?.from?.pathname || '/minha-conta';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      const { data } = await api.post('/auth/login-cliente', form);
      
      setAuth({
        token: data.token,
        user: data.user,
        tipo: 'cliente',
      });

      navigate(from, { replace: true });
    } catch (error: any) {
      setErro(error.response?.data?.message || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        {/* Voltar */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-700 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar para loja
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#FF6B35] to-[#00D9FF] flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-2xl">F3D</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Entrar na sua conta</h1>
            <p className="text-gray-500 mt-1">
              Acesse seus pedidos e histórico de compras
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Input
                label="E-mail"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="seu@email.com"
                required
              />
            </div>

            <div>
              <Input
                label="Senha"
                type="password"
                value={form.senha}
                onChange={(e) => setForm({ ...form, senha: e.target.value })}
                placeholder="••••••••"
                required
              />
            </div>

            {erro && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
                {erro}
              </div>
            )}

            <Button
              type="submit"
              variant="nuvem"
              className="w-full"
              disabled={loading}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">ou</span>
            </div>
          </div>

          {/* Criar conta */}
          <Link to="/criar-conta">
            <Button variant="outline" className="w-full">
              <UserPlus className="w-4 h-4 mr-2" />
              Criar nova conta
            </Button>
          </Link>

          {/* Links */}
          <div className="mt-6 text-center space-y-2">
            <Link 
              to="/recuperar-senha" 
              className="text-sm text-[#FF6B35] hover:underline block"
            >
              Esqueceu sua senha?
            </Link>
            <p className="text-sm text-gray-500">
              É administrador?{' '}
              <Link to="/superlogin" className="text-[#FF6B35] hover:underline">
                Acesse aqui
              </Link>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default LoginCliente;
